angular.module('bzVarnishModule', [])
